/**
 * Action de la partie receptions
 */
export const GET_RECEPTIONS = 'GET_RECEPTIONS';
export const GET_RECEPTIONS_SUCCESS = 'GET_RECEPTIONS_SUCCESS';
export const GET_RECEPTIONS_FAILURE = 'GET_RECEPTIONS_FAILURE';

export const getReceptions = params => ({
  type: GET_RECEPTIONS,
  payload: params
});

export const GET_RECEPTION = 'GET_RECEPTION';
export const GET_RECEPTION_SUCCESS = 'GET_RECEPTION_SUCCESS';
export const GET_RECEPTION_FAILURE = 'GET_RECEPTION_FAILURE';

export const getReception = receptionId => ({
  type: GET_RECEPTION,
  payload: receptionId
});

export const EXPORT_RECEPTION = 'EXPORT_RECEPTION';
export const EXPORT_RECEPTION_SUCCESS = 'EXPORT_RECEPTION_SUCCESS';
export const EXPORT_RECEPTION_FAILURE = 'EXPORT_RECEPTION_FAILURE';

export const exportReception = receptionId => ({
  type: EXPORT_RECEPTION,
  payload: receptionId
});
